module.exports = __webpack_public_path__ + "static/media/fa-light-300.57e3d393.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fontawesome/fa-light-300.woff
// module id = 757
// module chunks = 0